<button
  type="button"
  role="switch"
  [attr.aria-checked]="ariaChecked()"
  [attr.aria-label]="hasLabel() ? null : ariaLabel()"
  [disabled]="isDisabled()"
  [class]="controlClasses()"
  style="justify-content: inherit"
  (click)="toggle()"
  (blur)="onTouched()">
  <!-- empty:hidden, so a switch with nothing projected carries no gap either: an element that
       is not displayed takes no part in the flex layout. -->
  <span #labelBox [class]="labelClasses()"><ng-content /></span>

  <span [class]="trackClasses()">
    <span [class]="knobClasses()"></span>
  </span>
</button>
